import { BlockType, InlineType } from "../slate";
import * as Slate from "../slate";
import {
  ObjectType
} from "./types";
function isRichTextDTO(value) {
  return value != null && typeof value === "object" && !Array.isArray(value) && "document" in value;
}
function toTextDAO(node) {
  const typographyMark = node.marks?.find((mark) => mark.type === "typography");
  return [
    {
      text: node.text ?? "",
      typography: typographyMark?.data?.value ?? void 0
    }
  ];
}
function toInlineDAO(node) {
  switch (node.type) {
    case InlineType.Link:
      return [
        {
          children: node.nodes?.flatMap(toInlineOrTextDAO) ?? [],
          [node.type]: node.data,
          type: node.type
        }
      ];
    case InlineType.Code:
    case InlineType.SubScript:
    case InlineType.SuperScript:
      return [
        {
          children: node.nodes?.flatMap(toInlineOrTextDAO) ?? [],
          type: node.type
        }
      ];
    default:
      return [];
  }
}
function toInlineOrTextDAO(node) {
  switch (node.object) {
    case ObjectType.Inline:
      return toInlineDAO(node);
    case ObjectType.Text:
      return toTextDAO(node);
    default:
      return [];
  }
}
function toNodeDAO(node) {
  switch (node.object) {
    case ObjectType.Inline:
    case ObjectType.Text:
      return toInlineOrTextDAO(node);
    case ObjectType.Block:
      return [
        {
          type: node.type,
          textAlign: node?.data && "textAlign" in node.data ? node?.data.textAlign : void 0,
          children: node.nodes == null || node.nodes && node.nodes.length === 0 ? [{ text: "" }] : node.nodes.flatMap(toNodeDAO)
        }
      ];
    default:
      return [];
  }
}
function richTextDTOtoSelection(data) {
  if (data.selection?.anchor?.offset != null && data.selection.anchor.path != null && data.selection?.focus?.offset != null && data.selection.focus.path != null)
    return {
      anchor: {
        offset: data.selection.anchor.offset,
        path: data.selection.anchor.path
      },
      focus: {
        offset: data.selection.focus.offset,
        path: data.selection.focus.path
      }
    };
  return null;
}
function richTextDTOtoDAO(data) {
  return data.document?.nodes?.flatMap(toNodeDAO) ?? [
    { type: BlockType.Default, children: [{ text: "" }] }
  ];
}
function toInlineOrTextDTO(node) {
  if (Slate.isText(node)) {
    return [
      {
        text: node.text,
        object: "text",
        marks: node.typography ? [
          {
            data: {
              value: node.typography
            },
            type: "typography",
            object: "mark"
          }
        ] : []
      }
    ];
  }
  switch (node.type) {
    case InlineType.Link:
      return [
        {
          object: ObjectType.Inline,
          nodes: node.children.flatMap(toInlineOrTextDTO),
          type: node.type,
          data: node.link ?? void 0
        }
      ];
    case InlineType.Code:
    case InlineType.SubScript:
    case InlineType.SuperScript:
      return [
        {
          object: "inline",
          nodes: node.children.flatMap(toInlineOrTextDTO),
          type: node.type,
          data: {}
        }
      ];
  }
}
function toNodeDTO(node) {
  if (Slate.isText(node) || Slate.isInline(node))
    return toInlineOrTextDTO(node);
  if (Slate.isBlock(node)) {
    return [
      {
        type: node.type,
        data: node.textAlign ? {
          textAlign: node.textAlign
        } : {},
        object: "block",
        nodes: node.children?.flatMap(toNodeDTO) ?? []
      }
    ];
  }
  return [];
}
function toSelectionDTO(selection) {
  if (selection == null)
    return void 0;
  return {
    isFocused: false,
    marks: void 0,
    object: "selection",
    anchor: {
      offset: selection.anchor.offset,
      path: selection.anchor.path,
      object: "point"
    },
    focus: {
      offset: selection.focus.offset,
      path: selection.focus.path,
      object: "point"
    }
  };
}
function richTextDAOToDTO(children, selection) {
  return {
    document: {
      data: void 0,
      nodes: children.flatMap(toNodeDTO),
      object: "document"
    },
    object: "value",
    selection: toSelectionDTO(selection),
    annotations: void 0,
    data: void 0
  };
}
export {
  isRichTextDTO,
  richTextDAOToDTO,
  richTextDTOtoDAO,
  richTextDTOtoSelection,
  toSelectionDTO
};
//# sourceMappingURL=dto.js.map